<template>
  <div>
    <h1 class="title">
      {{ deviceName }}-火灾报警控制器操作台({{ deviceVersion | dic("SENU095") }}
      )
    </h1>
    <div class="gts5001-container">
      <div class="main-box column-center">
        <!-- 上 -->
        <div class="top-box flex-between">
          <div
            v-for="(item, index) in btnList"
            :key="index"
            class="light-item flex-row"
            :class="[index === 8 || index === 13 || index === 18 ? 'pink' : 'blue']"
          >
            <div class="light">
              <span class="point checked" :class="[btnClass[item.type]]"></span>
              <span class="name">{{ item.title }}</span>
            </div>
          </div>
        </div>
        <!-- 中 -->
        <div class="middle-box" v-if="deviceVersion == 3">
          <div class="top flex-between">
            <div class="screen">
              <div class="inside-screen">
                {{ timeH }}
              </div>
            </div>
            <div class="yuan column-center">
              <div class="doit"></div>
              <div class="doit"></div>
            </div>
            <div class="screen" style="margin-right: 30px">
              <div class="inside-screen">
                {{ timeM }}
              </div>
            </div>
          </div>
          <!-- <div class="text">时钟</div> -->
        </div>
        <div class="other" v-else>
          <div class="screen-box"></div>
        </div>
        <!-- 下 -->
        <div class="bottom-box">
          <div class="top-btns flex-between">
            <div
              class="fire-btn ctl-btn lh40"
              name="2"
              @click="handleCheckClick('消音', 2)"
            >
              <span>消音</span>
            </div>
            <div
              class="fire-btn ctl-btn lh18"
              name="33"
              @click="handleCheckClick('警报器/消音启动', 33)"
            >
              <span>警报器<br />消音启动</span>
            </div>
            <div
              class="fire-btn ctl-btn lh18"
              name="32"
              @click="handleCheckClick('火警传输/直接控制', 32)"
            >
              <span>火警传输<br />直接控制</span>
            </div>
            <div
              class="fire-btn ctl-btn lh40"
              name="1"
              @click="handleCheckClick('复位', 1)"
            >
              <span>复位</span>
            </div>
          </div>
          <!-- 键盘 -->
          <div class="keybord-box flex-between">
            <div
              v-for="(items, indexs) in keyBordList"
              :key="indexs"
              :name="items.value"
              class="key-btn ctl-btn"
              @click="handleCheckClick(items.num + '/' + items.text, items.value)"
            >
              <!-- <i
                v-show="items.text === '系统设置'"
                class="icon iconfont-lunan icon-lunan-kongge"
              ></i> -->
              <span class="num-span">{{ items.num }}</span>
              <i
                v-show="items.value === '5'"
                class="icon iconfont-lunan icon-lunan-xiangshang"
              ></i>
              <i
                v-show="items.value === '6'"
                class="icon iconfont-lunan icon-lunan-xiangxia"
              ></i>
              <span class="text-span">{{ items.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "./minx";
import { Dic } from "$utils";
export default {
  mixins: [mixin],
  props: {
    deviceName: {
      type: String,
      default: () => {
        return "";
      },
    },
    deviceVersion: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      btnList: [
        {
          title: "火警",
          type: "1",
        },
        {
          title: "故障",
          type: "1",
        },
        {
          title: "启动",
          type: "1",
        },
        {
          title: "延时",
          type: "1",
        },
        {
          title: "警报器消音",
          type: "1",
        },
        {
          title: "监管",
          type: "1",
        },
        {
          title: "系统故障",
          type: "1",
        },
        {
          title: "反馈",
          type: "1",
        },
        {
          title: "喷洒允许",
          type: "1",
        },
        {
          title: "声光警报器故障",
          type: "1",
        },
        {
          title: "屏蔽",
          type: "1",
        },
        {
          title: "备电工作",
          type: "1",
        },
        {
          title: "自动允许",
          type: "1",
        },
        {
          title: "喷洒请求",
          type: "1",
        },
        {
          title: "火警传输 动作/反馈",
          type: "1",
        },
        {
          title: "声光警报器屏蔽",
          type: "1",
        },
        {
          title: "主电工作",
          type: "1",
        },
        {
          title: "自检",
          type: "1",
        },
        {
          title: "气体喷洒",
          type: "1",
        },
        {
          title: "火警传输 故障/屏蔽",
          type: "1",
        },
      ],
      btnClass: {
        0: "red",
        1: "green",
        2: "gray",
      },
      keyBordList: [
        {
          num: "1",
          text: "自检",
          value: "10",
        },
        {
          num: "2",
          text: "对时",
          value: "11",
        },
        {
          num: "3",
          text: "公式查询",
          value: "12",
        },
        {
          num: "+",
          text: "TAB",
          value: "34",
        },
        {
          num: "",
          text: "",
          value: "5",
        },
        {
          num: "4",
          text: "屏蔽",
          value: "13",
        },
        {
          num: "5",
          text: "取消屏蔽",
          value: "14",
        },
        {
          num: "6",
          text: "喷洒控制",
          value: "15",
        },
        {
          num: "x",
          text: "窗口切换",
          value: "35",
        },
        {
          num: "",
          text: "",
          value: "6",
        },
        {
          num: "7",
          text: "启动",
          value: "16",
        },
        {
          num: "8",
          text: "停动",
          value: "17",
        },
        {
          num: "9",
          text: "现场编程",
          value: "18",
        },
        {
          num: "&",
          text: "启动方式",
          value: "39",
        },
        {
          num: "",
          text: "确认",
          value: "3",
        },
        {
          num: "*",
          text: "设备检查",
          value: "19",
        },
        {
          num: "0",
          text: "记录检查",
          value: "9",
        },
        {
          num: "□",
          text: "系统设置",
          value: "38",
        },
        {
          num: "=",
          text: "打印控制",
          value: "37",
        },
        {
          num: "",
          text: "取消",
          value: "4",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    changeBgColor(isSuccess, btnListCode) {
      // console.log(isSuccess, btnListCode);
      // btnListCode.forEach((item) => {
      //   let divItem = document.getElementsByName(item);
      //   divItem.forEach((data) => {
      //     if (isSuccess) data.classList.add("greenBg");
      //     else data.classList.add("redBg");
      //   });
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.rChecked {
  background: red !important;
}
.redBg {
  background: red !important;
  color: #fff !important;
}

.greenBg {
  background-color: green !important;
}
.gChecked {
  background: rgb(123, 123, 123);
}
@import "~@src/common/assets/style/mixin";
.checkedIng {
  @include set_theme_color(color, main-button-bgcolor);
}
.title {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: center;
  line-height: 20px;
}
.gts5001-container {
  width: 100%;
  // height: 50vh;
  background: #a9aaa4;
  opacity: 1;
  border-radius: 10px;
  padding: 10px;
  .ctl-btn {
    &:hover {
      opacity: 0.6 !important;
      cursor: pointer;
    }
  }
  .lh40 {
    line-height: 40px;
  }
  .lh18 {
    line-height: 18px;
  }
  .red {
    background: linear-gradient(180deg, #ff0000 0%, #800000 100%);
  }
  .green {
    background: linear-gradient(180deg, #00ce6f 0%, #006738 100%);
  }
  .gray {
    background: linear-gradient(180deg, #eeeeee 0%, #a1a1a1 100%);
  }
  .blue {
    background: #2fbbeb;
  }
  .pink {
    background: #f56285;
  }
  .main-box {
    width: 100%;
    height: 100%;
    background: #8c9492;
    border: 1px solid #707070;
    opacity: 1;
    border-radius: 20px;
    padding: 10px 50px;
    align-items: center;
    .top-box {
      width: 100%;
      height: 40%;
      flex-wrap: wrap;
      padding: 2% 0;
      box-sizing: border-box;
      .light-item {
        width: 100px;
        height: 35px;
        border: 1px solid #404040;
        opacity: 1;
        border-radius: 6px;
        margin-bottom: 4px;
        .light {
          width: 100%;
          height: 100%;
          text-align: left;
          padding: 0px 5px;
          display: flex;
          flex-direction: row;
          align-items: center;
          span {
            display: inline-block;
            width: 60px;
            margin-right: 5px;
          }
          .point {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50px;
            box-shadow: 0px 0px 0px 3px #fff;
            -webkit-box-shadow: 0px 0px 0px 3px #fff;
            -moz-box-shadow: #fff 0px 0px 3px;
          }
          .name {
            margin-left: 5px;
          }
        }
      }
    }
    .other {
      width: 582px;
      height: 35%;
      background: #000000;
      border: 1px solid #ffffff;
      opacity: 1;
      border-radius: 15px;
      padding: 6px;
      .screen-box {
        width: 100%;
        height: 100%;
        background: #adbfb2;
        border: 1px solid #555a56;
        opacity: 1;
        border-radius: 10px;
      }
    }
    .middle-box {
      width: 75%;
      height: 20%;
      border: 2px solid black;
      border-radius: 18px;
      padding: 10px 0;
      box-sizing: border-box;
      .top {
        width: 100%;
        height: 85%;
        align-items: center;
        .screen {
          width: 147px;
          height: 100%;
          // background: #000000;
          // border: 1px solid #ffffff;
          opacity: 1;
          border-radius: 15px;
          padding: 4px;
          &:nth-child(1) {
            margin-left: 30px;
          }
          .inside-screen {
            width: 139px;
            font-size: 37px;
            line-height: 55px;
            height: 100%;
            background: rgba(0,0,0,0.7);
            border-radius: 12px;
            text-align: center;
            text-shadow: 0 0 10px #E00B64, 0 0 10px #E00B64, 0 0 10px #E00B64, 0 0 10px #E00B64;
          }
        }
        .yuan {
          width: 40px;
          height: 100%;
          align-items: center;
          .doit {
            width: 10px;
            height: 10px;
            background: #ffffff;
            // border: 1px solid #707070;
            border-radius: 50%;
            opacity: 1;
            box-shadow: 0px 0px 7px 7px #f56285;
            &:nth-child(1) {
              margin-bottom: 20px;
            }
          }
        }
      }
      .text {
        letter-spacing: 20px;
        font-size: 18px;
        padding-left: 20px;
      }
    }
    .bottom-box {
      width: 95%;
      height: 43%;
      margin-top: 10px;
      .top-btns {
        height: 25%;
        margin-bottom: 12px;
        .fire-btn {
          width: 104px;
          height: 40px;
          background: #f56285;
          border: 1px solid #292929;
          // background: linear-gradient(180deg, #ff534b 0%, #802a26 100%);
          opacity: 1;
          border-radius: 20px;
          text-align: center;
        }
      }
      .keybord-box {
        height: 95%;
        flex-wrap: wrap;
        .key-btn {
          width: 90px;
          height: 40px;
          border: 1px solid #404040;
          background: linear-gradient(180deg, #767676 0%, #262626 100%);
          opacity: 1;
          border-radius: 18px;
          text-align: center;
          margin-bottom: 5px;
          margin-right: 10px;
          font-size: 12px;
          &:nth-child(5) {
            line-height: 30px;
          }
          &:nth-child(10) {
            line-height: 30px;
          }
          &:nth-child(15) {
            line-height: 30px;
          }
          &:nth-child(20) {
            line-height: 30px;
          }
          span {
            display: block;
          }
        }
      }
    }
  }
}
</style>
